import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/app-shell";
import { PageLoading } from "./components/loading";

const ProjectsPage = lazy(() => import("./pages/projects-page"));
const NewProjectPage = lazy(() => import("./pages/new-project-page"));
const ProjectWorkspace = lazy(() => import("./pages/project-workspace"));
const ConnectionCallback = lazy(() => import("./pages/connection-callback"));

function Deferred({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
}

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Deferred><ProjectsPage /></Deferred>} />
        <Route path="archive" element={<Deferred><ProjectsPage archived /></Deferred>} />
        <Route path="projects/new" element={<Deferred><NewProjectPage /></Deferred>} />
        <Route
          path="projects/:projectId/:section?"
          element={<Deferred><ProjectWorkspace /></Deferred>}
        />
      </Route>
      <Route
        path="connections/callback"
        element={<Deferred><ConnectionCallback /></Deferred>}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
